var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-d-loader__container"},[_c('img',{staticClass:"r-d-loader__svg",attrs:{"src":"/images/shared/Robins-And-Day-Loader-Purple.svg","alt":"Loading"}})])
}]

export { render, staticRenderFns }